import api from './axiosConfig';
export const listParticipants = (assessmentId, params) =>
  api.get(`/api/v1/assessments/${assessmentId}/participants`, { params });
export const getParticipant   = (id) => api.get(`/api/v1/participants/${id}`);
export const getSubmission    = (id) => api.get(`/api/v1/submissions/${id}`);
